import compact from 'lodash/compact';
import { Fragment } from 'react';

import { localizeRelativeTime } from 'utils/i18nHelpers';

import { isCreatedBlock } from './utils/isCreatedBlock';
import { useTranslations } from '../../../hooks/useTranslations';
import { ImageMetadata } from '../../../types';

// the bullet-separated list of details about the image
export const BlockDetails = ({ metadata }: { metadata: Partial<ImageMetadata> }) => {
  const { t } = useTranslations();
  const createdDate = isCreatedBlock(metadata) ? new Date(metadata.created).toString() : undefined;
  const relativeCreated = localizeRelativeTime(createdDate);
  const details = compact([
    isCreatedBlock(metadata) ? t('caption.campaignId', { id: metadata.campaignId }) : undefined,
    metadata.width && metadata.height && (
      <>
        {metadata.width}&nbsp;&times;&nbsp;{metadata.height}
        {t('abbreviation.pixel')}
      </>
    ),
    isCreatedBlock(metadata) ? t('caption.created', { when: relativeCreated.label }) : undefined,
  ]);

  return (
    <>
      {details.map((detail, idx, ary) => {
        return (
          <Fragment key={`detail-${idx}`}>
            <>{detail}</>
            {idx < ary.length - 1 ? <> &bull; </> : ''}
          </Fragment>
        );
      })}
    </>
  );
};
